module.exports = "    <div ng-class=\"{ Contain: element.data.contain }\">\n        <sgcontenteditor-editor-elements-display editor=\"editor\" educator=\"educator\" elements=\"element.children\" tabdepth=\"tabdepth\"></sgcontenteditor-editor-elements-display>\n    </div>\n"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/elements/section.html
// module id = 385
// module chunks = 0